import styles from './index.module.css'
import cn from 'clsx'

import React from 'react'
import { SuccessCheck } from 'components/ui/icon'
type CircleProps = {
  radius: number
  thickness: number
  className?: string
  progress?: number
  color?: string
}

const Circle = ({
  radius,
  thickness,
  className,
  progress = 100,
  color,
}: CircleProps) => {
  const circumference = 2 * Math.PI * radius
  const progressCircumference = circumference * progress
  return (
    <circle
      className={className}
      cx={radius + thickness / 2}
      cy={radius + thickness / 2}
      r={radius}
      style={{
        stroke: color,
        strokeDasharray: `${progressCircumference} ${circumference}`,
        transition: `stroke-dasharray 0.25s`,
      }}
    />
  )
}

type Props = {
  progress?: number
  done?: boolean
  indeterminate?: boolean
  icon?: any
  radius?: number
  thickness?: number
  color?: string
  style?: Record<string, any>
}

const CircleProgress = ({
  progress,
  done = false,
  indeterminate = false,
  icon: Icon = SuccessCheck,
  radius = 14,
  thickness = 4,
  color,
  style,
}: Props): React.ReactNode => {
  const size = 2 * radius + thickness
  const inferredProgress = done ? 100 : progress || 0
  return (
    <div className={styles.wrapper} style={style}>
      {done && <Icon className={styles.icon} size="16" />}
      <svg
        viewBox={`0 0 ${size} ${size}`}
        width={size}
        height={size}
        className={cn({
          [styles.spin]: indeterminate,
        })}
      >
        <Circle
          radius={radius}
          thickness={thickness}
          className={cn(styles.circle, styles.track)}
          progress={100}
        />
        <Circle
          radius={radius}
          thickness={thickness}
          className={cn(styles.circle, styles.fillShadow)}
          progress={inferredProgress}
        />
        <Circle
          radius={radius}
          thickness={thickness}
          className={cn(styles.circle, styles.fill)}
          color={color}
          progress={inferredProgress}
        />
      </svg>
    </div>
  )
}

export default CircleProgress
